'use strict';

import {Component, EventEmitter, Inject, Output, Input} from 'ng-metadata/core';
import {SearchFieldsService} from '../search.fields.service';
import {SearchBarService} from './searchBar.service';
import {VoiceSearchToastService} from './voiceSearchToast.service';
import {AutoComplete} from '../autocomplete.service';
import {IAlertMsg} from '../../infra/widgets/alerts/alertMsg.interface';
import {AlertFactory, ALERT_MSG_TYPE} from '../../infra/widgets/alerts/alertFactory.service';
import {preventStateReload} from '../../infra/annotations';
import {PrimolyticsService, beacon} from '../../analytics/primolytics.service';
import {AddQueryToSavedSearchesService} from '../../search/savedQueries/addQueryToSavedSearches/addQueryToSavedSearches.service';

import {
    getSearchScopesMap, updateSearchScopesMap, getVid, getFindInDbPerTabs,
    isAutoSearchOnTabChange
} from '../../appConfig/appConfigForward';
import {getScopeList} from '../../appConfig/appConfigForward';
import {SmoothScrollUtil} from "../../nddUtils/smoothScrollUtil.service";
import {StringUtils} from '../../nddUtils/stringUtils.service';
import {MediaQueries} from '../../infra/mediaQueries.service';

import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {SearchUtil} from '../../nddUtils/searchUtil.service';

import {TabsAndScopesSelectorService} from './tabsAndScopesSelector/tabsAndScopesSelector.service';
import {JwtUtilService} from '../../security/jwtUtil.service';
import {getAttributesMap} from '../../appConfig/appConfigForward';
import {SearchService} from "../search.service";
import {StorageUtil} from "../../infra/storageUtil.service";
import {getBackendSystem} from "../../appConfig/appConfigForward"

import {PreFiltersService} from "../preFilters/preFilters.service";

let isEmpty = require('lodash/isEmpty');
let annyang = require('annyang');

interface Suggestion {
    tab?: string;
    display?: string;
}

const MAX_AUTOCOMPLETE_ROWS = 8;

const find = require('lodash/find');

@Component({
    'selector': 'prm-search-bar',
    templateUrl: 'components/search/searchBar/search-bar.html',
})


export class PrmSearchBar {
    @Input() private hasSearchResults: string;
    private query: string;
    private _scopeField: Object;
    private _selectedTab: string;
    private scopesDialerConfiguration: ScopesDialerConfiguration;
    @Output() private searchEvent = new EventEmitter();
    private _signInAlert: IAlertMsg;
    private showTabsAndScopes = false;
    private tabs: Suggestion[];
    private searchScopesMap = getSearchScopesMap();
    private selectedItem: Suggestion;
    private typedQuery: string;
    private _placeHolderText: string;
    private _clearButtonText: string;
    private _searchFieldText: string;
    private DEFAULT_TARGET_OPERATOR = 'any'
    private DEFAULT_SEARCH_OPERATOR = 'contains';
    private autocompleteLength: number;
    private _isShowFindDBButton: boolean;

    private vid = getVid();
    private timeoutPromise;

    public pFilters = {};

    constructor(@Inject('$stateParams') private $stateParams: angular.ui.IStateParamsService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('scopesIcons') private scopesIcons: Object[],
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('searchBoxIcons') private searchBoxIcons: Object[],
                @Inject('$mdDialog') private $mdDialog,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$mdToast') private $mdToast: ng.material.IToastService,
                private mediaQueries: MediaQueries,
                private searchFieldsService: SearchFieldsService,
                private autocompleteService: AutoComplete,
                private searchBarService: SearchBarService,
                private voiceSearchToastService: VoiceSearchToastService,
                private alertService: AlertFactory,
                private addQueryToSavedSearchesService: AddQueryToSavedSearchesService,
                private smoothScrollUtil: SmoothScrollUtil,
                private stringUtil: StringUtils,
                private searchUtil: SearchUtil,
                private tabsAndScopesSelectorService: TabsAndScopesSelectorService,
                private jwtUtilService: JwtUtilService,
                private searchService: SearchService,
                private storageUtil: StorageUtil,
                private preFiltersService: PreFiltersService,
                private primolyticsService: PrimolyticsService) {

        this.tabs = [];
        Object.keys(this.searchScopesMap).slice(0, MAX_AUTOCOMPLETE_ROWS).forEach((e, i) => {
            let code = 'tabbedmenu.' + e + '.label';
            let tab = {tab: e, displayName: ''};
            this.$translate(code).then((translation) => {
                tab.displayName = translation
            });
            this.tabs.push(tab);

        });

        $translate('nui.search.placeholder').then((translation) => {
            this._placeHolderText = translation
        });
        this.initStateFromUrl($stateParams);
        this.$scope.$on('$stateChangeSuccess', (event, toState) => {
            if (toState.name === STATE_NAMES.SEARCH) {
                this.initStateFromUrl($stateParams);
            }
        });

        $translate('nui.searchField.clear').then((translation) => {
            this._clearButtonText = translation
        });

        $translate('nui.aria.search.searchField').then((translation) => {
            this._searchFieldText = translation
        });

        this.scopesDialerConfiguration = {
            display: false,
            isOpen: false,
            direction: 'down',
            iconsArray: scopesIcons,
            autoHideToolTip: false,
            toolTipDelay: 100,
            toolTipDirection: 'right',
            tooTipDefaultOpen: false
        };
        this._signInAlert = this.alertService.create(ALERT_MSG_TYPE.SIGNIN);
        this._signInAlert.show('nui.search.tnsearch.error.authorization', true);
        if (getBackendSystem() !== 'suprima') {
            this.updateShowFindDBButton();
        }

    }

    public onChangeTabEvent(event) {
        if (isAutoSearchOnTabChange()) { // tabsRemote is true we need to invoke a search on tab change
            setTimeout(() => {
                this.search(event)
            }, 0); //we need a timeout so that _selectedTab is updated before search is invoked
        }
    }

    get mainSearchField() {
        return this.searchFieldsService.mainSearch;
    }

    set mainSearchField(mainSearchField) {
        this.searchFieldsService.mainSearch = mainSearchField;
    }

    get scopeField() {
        return this._scopeField;
    }

    set scopeField(scopeField) {
        this._scopeField = scopeField;
    }

    get selectedTab() {
        return this._selectedTab;
    }

    set selectedTab(tab) {
        this._selectedTab = tab;
    }

    get autoCompleteItems() {
        return this.searchBarService.autoCompleteItems;
    }

    set autoCompleteItems(items) {
        this.searchBarService.autoCompleteItems = items;
    }

    get showSignIn() {
        return this.searchBarService.showSignIn;
    }

    get placeHolderText() {
        return this._placeHolderText;
    }

    get clearButtonText() {
        return this._clearButtonText;
    }

    get searchFieldText() {
        return this._searchFieldText;
    }

    get signInAlert(): IAlertMsg {
        return this._signInAlert;
    }

    get advancedSearch() {
        return this.searchFieldsService.advancedSearch;
    }

    get isPreFilterEnable() {
        return !this.advancedSearch && this.preFiltersService.isPreFilterEnable(this.selectedTab);
    }

    public search(event) {
        this.onSubmit();
    }

    public getSubmitAriaLabelCode() {
        if (this.isPreFilterEnable) {
            return 'nui.aria.continuePreFilters';
        }
        return 'nui.aria.submitSearch';
    }

    showTabsAndScopesVal() {
        if (this.showTabsAndScopes == false) {
            if (this.tabs.length === 1) {
                return true;
            }
            return false;

        }
        return this.showTabsAndScopes;

    }

    private ngOnInit() {
        this.autocompleteLength = this.calculateAtocompleteLength();
    }

    private calculateAtocompleteLength() {
        if (this.mediaQueries.xs) {
            return 51;
        }
        if (this.mediaQueries.sm) {
            return 58;
        }
        if (this.mediaQueries.md) {
            return 77;
        }
        if (this.mediaQueries.lgPlus) {
            return 105;
        }
        if (this.mediaQueries.lg) {
            return 94;
        }

        // then it needs to be this.mediaQueries.xl
        return 114;
    }

    private initStateFromUrl($stateParams) {

        let curScope = this.searchUtil.getValidScope($stateParams.search_scope);
        let curTab = $stateParams.tab;

        if (!$stateParams.query && !curTab && !curScope) {
            this.selectedTab = this.tabs[0].tab;
            this.scopeField = this.searchScopesMap[this.selectedTab][0]['scope-id'];
            return;
        }

        if (curTab) {
            this.selectedTab = curTab;
            if (curScope) {
                this.scopeField = curScope;
            } else {
                this.scopeField = this.searchScopesMap[this.selectedTab][0]['scope-id'];
            }
        } else {
            if (curScope) {
                this.scopeField = curScope;
                this.selectedTab = find(getScopeList(), (scope) => scope['scope-id'] === this.scopeField).tab;
            } else {
                this.selectedTab = this.tabs[0].tab;
                this.scopeField = this.searchScopesMap[this.selectedTab][0]['scope-id'];
            }
        }
        this.searchFieldsService.tab = this.selectedTab;
        this.showTabsAndScopes = true;
        return;
    }

    @preventStateReload
    private switchAdvancedSearch() {
        this.searchFieldsService.advancedSearch = !this.searchFieldsService.advancedSearch;
        if (!this.searchFieldsService.advancedSearch) {
            this.smoothScrollUtil.focusOn('searchBar');
        }
        this.$location.search('mode', this.searchFieldsService.advancedSearch ? 'advanced' : 'simple');
        this.$timeout(() => {
            if (this.advancedSearch == true) {
                return document.querySelector('#advanced-search').focus();
            }
        }, 100);

    }

    private parseResults(autocompleteResults) {
        let results = [];
        if (this.tabs.length > 1) {
            results.push(this.tabs);
        }
        if (autocompleteResults.length > 0) {
            let parsedResults = autocompleteResults
                .slice(0, MAX_AUTOCOMPLETE_ROWS - this.tabs.length)
                .map((e) => {
                        let aclength = this.autocompleteLength;
                        let short = this.stringUtil.abbreviate(e, aclength);
                        let json = {
                            display: e,
                            shortDisplay: short
                        };
                        return json;
                    }
                );
            results.push(parsedResults);
        }

        return results;

    }

    private autocompleteQuery(searchText) {
        this.typedQuery = searchText;
        let body = document.getElementsByTagName('body')[0];
        if (this.autocompleteService.isAutocompleteEnabledFor(this.scopeField)) {
            if (this.hasSearchResults === 'false') {
                body.setAttribute('style', 'overflow-x: hidden'); //prevent screen "wobble"
            }

            this.autoCompleteItems = this.autocompleteService
                .search(searchText, this.scopeField)
                .then(
                    (e) => {
                        let ret = this.parseResults(e);
                        return ret;
                    },
                    () => {
                        let ret = this.parseResults([]);
                        return ret;
                    }
                );
        } else {
            this.autoCompleteItems = this.parseResults([]);
        }

    }

    private onSelectItem() {
        if (!this.selectedItem) {
            return;
        }
        if (this.selectedItem.tab) {
            this.selectedTab = this.selectedItem.tab;
            this.scopeField = this.searchScopesMap[this.selectedTab][0]['scope-id'];
        }
        this.onSubmit();
        if (getBackendSystem() !== 'suprima') {
            this.updateShowFindDBButton();
        }
    }

    private onSubmit() {
        this.showTabsAndScopes = true;
        if (this.mainSearchField) {
            window.appPerformance.timeStamps['search button clicked'] = Date.now();
            this.typedQuery = this.mainSearchField;
            this.autoCompleteItems = [];
            if (!this._scopeField && !this.selectedTab) {
                this.selectedTab = this.tabs[0].tab;
                this.scopeField = this.searchScopesMap[this.selectedTab][0]['scope-id'];
            }
            this.searchFieldsService.tab = this.selectedTab;
            this.searchFieldsService.scope = this.scopeField;
            if (this.$location.search().tab !== this.selectedTab) {
                //                this.addTabToUrl();
            }

            let eventData = this.createSearchEvent();

            this.searchEvent.emit(eventData);
            let s = this.$scope as any;
            s.$$childHead.$mdAutocompleteCtrl.hidden = true;
        }
    }

    private onVoiceSearchStart() {
        if (annyang) {
            let _this = this;
            let commands = {
                '*searchString': function (searchString) {
                    _this.executeVoiceSearch(searchString, _this);
                }
            };

            annyang.removeCommands();
            annyang.addCommands(commands); // Add the commands to annyang
            annyang.start();// Start listening.
            this.openVoiceSearchToast();
        }
    }

    private executeVoiceSearch(searchString, _this) {
        _this.searchService.cameFromState = 'voiceSearch';
        _this.mainSearchField = searchString;
        _this.executeVoiceSearchBeacon();
        _this.onSubmit();
        _this.voiceSearchToastService.executeVoiceSearch(searchString);
    }

    private openVoiceSearchToast() {
        let templateString = '<prm-voice-search-toast></prm-voice-search-toast>';

        this.$mdToast.show({
            hideDelay: 60000,
            position: 'top right',
            template: templateString
        }).then(() => {
            this.addQueryToSavedSearchesService.onToastClose()
        });
    }

    @beacon({'p': 'voiceSearch', 'op': 'voiceSearch'})
    public executeVoiceSearchBeacon() {
    }

    private createSearchEvent() {
        let eventData = {
            mainSearchField: this.getMainSearchField(),
            scopeField: this.scopeField,
            tab: this.selectedTab,
            mode: null,
            facet: [],
            mfacet: []
        };

        if (this.pFilters.mediaType) {
            eventData.pfilter = ['pfilter,exact,' + this.pFilters.mediaType];

            if (getBackendSystem() === 'suprima') {
                eventData.pfilter = ['rtype,exact,' + this.pFilters.mediaType];
            }
        }

        this.searchService.cameFromState = (this.isPreFilterSubmitted()) ? 'preFilter' : this.searchService.cameFromState;

        return eventData;
    }

    private getMainSearchField() {
        let queryArray = [];
        queryArray.push(this.pFilters.targetField || this.DEFAULT_TARGET_OPERATOR);
        queryArray.push(this.pFilters.operator || this.DEFAULT_SEARCH_OPERATOR);
        queryArray.push(this.mainSearchField);
        return queryArray.join(",");
    }

    @preventStateReload
    private addTabToUrl() {
        this.$location.search('tab', this.searchFieldsService.tab);
    }

    public updateShowFindDBButton(tab?) {
        let chosenTab = tab ? tab : this.selectedTab;
        this.tabsAndScopesSelectorService.updateIsRemoteTab(chosenTab);
        let configurdByTab = getFindInDbPerTabs()[chosenTab] ? getFindInDbPerTabs()[chosenTab] : false;
        this.isShowFindDBButton = this.tabsAndScopesSelectorService.isRemoteTab || configurdByTab;
    }

    public isPreFilterSubmitted() {
        return this.pFilters.mediaType ||
            (this.pFilters.targetField && (this.pFilters.targetField !== this.DEFAULT_TARGET_OPERATOR)) ||
            (this.pFilters.operator && (this.pFilters.operator !== this.DEFAULT_SEARCH_OPERATOR));
    }

    private onFindDBDialogClose(data: { selectedSetId: string }) {
        this.tabsAndScopesSelectorService.updateScopes().then((res) => {
            updateSearchScopesMap(res.data);
            if (data && data.selectedSetId) {
                let selectedSetId = data.selectedSetId === 'Current Session' ? 'Selected_Databases' : data.selectedSetId;
                let tabName = this.tabsAndScopesSelectorService.findTabByScopeName(selectedSetId);
                if (!tabName) {
                    console.log('error could not find "find DB" selected scope in any tab');
                    return;
                }
                let params = this.$state.params;
                params['tab'] = tabName;
                params['search_scope'] = selectedSetId;
                this.$state.transitionTo(this.$state.current, params, {reload: true});
            } else {
                this.$state.reload(); //reload state to refresh the scopes and tabs list
            }
        });
    }

    public openFdbIframe() {
        let vm = this;
        let findDBDialogPromise: ng.IPromise<Object> = this.$mdDialog.show({
            bindToController: true,
            controller: function () {
                this.displayFDBNothingSelectedErr = false;
                let handle = vm.jwtUtilService.getPdsHandle();//pds_handle
                let userId = !handle ? vm.jwtUtilService.getDecodedToken()['user'] : '';
                this.getUrl = function () {
                    return vm.$location.protocol() + '://' + vm.$location.host() + ':' + vm.$location.port() + '/primo_library/libweb/action/searchDB.do?fn=nuiSearchDbIframe&vid=' + vm.vid + '&pds_handle=' + handle + '&guestID=' + userId;
                };
                this.closeDialog = function () {
                    vm.$mdDialog.hide();
                };

                this.goToSearch = function () {
                    let retrievedObject = vm.storageUtil.localStorage.getItem('selectedSetId'); //retrieve scope id from local storage
                    if (retrievedObject) {
                        vm.storageUtil.localStorage.removeItem('selectedSetId'); //once we have retrieved the selected id we delete it to prevent confusion in the future
                        let selectedSetId = JSON.parse(retrievedObject);
                        vm.$mdDialog.hide(selectedSetId); //set the data for the findDBDialogPromise callback
                    } else {
                        this.displayFDBNothingSelectedErr = true; // if retrieved object is null it means that nothing was selected in find db iframe and we display error message
                    }
                }
            },
            controllerAs: 'ctrl',
            templateUrl: 'components/search/topbar/mainMenu/find-db-dialog-template.html'
        });

        findDBDialogPromise.then((data: { selectedSetId: string }) => {
            this.onFindDBDialogClose(data)
        });


    }

    get facetToLeft() {
        let viewConfig = getAttributesMap();
        return viewConfig['selectedFacetLocation'] === 'left';
    }

    get isShowFindDBButton(): boolean {
        return this._isShowFindDBButton;
    }

    set isShowFindDBButton(value: boolean) {
        this._isShowFindDBButton = value;
    }

    get showVoiceSearchButton(): boolean {
        let viewConfig = getAttributesMap();
        return annyang && viewConfig['displayVoiceSearch'] && (getBackendSystem() !== 'suprima');
    }

    get isLandscapeView(): boolean {
        return window.matchMedia("(orientation: landscape)").matches;
    }
}

interface ScopesDialerConfiguration {
    display: boolean;
    isOpen: boolean;
    direction: string;
    iconsArray: Object[];
    autoHideToolTip: boolean;
    toolTipDelay: number;
    toolTipDirection: string;
    tooTipDefaultOpen: boolean;
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchBar/searchBar.directive.ts